import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { Button } from 'foundations-components/transitional/components/Button';
// @ts-expect-error not converted to TS
import Images from 'LoginUI/images/imageUrls';
import { useEffect, useState } from 'react';
import { arePasskeysSupported } from '../../../utils/arePasskeysSupported';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isIframed = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
};
const PasskeyLoginButton = ({
  onClick,
  disabled
}) => {
  const [passkeysSupported, setPasskeysSupported] = useState(false);
  useEffect(() => {
    setPasskeysSupported(arePasskeysSupported());
  }, []);
  const disabledData = {
    isDisabled: !passkeysSupported || disabled,
    tooltipMessage: !passkeysSupported ? 'login.unsupported.passkeys' : `login.smartLogin.disabledButtonHelp`
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: disabledData.tooltipMessage
    }),
    disabled: !disabledData.isDisabled,
    children: /*#__PURE__*/_jsx(Button, {
      use: "primary",
      "data-test-id": "passkey-sign-in",
      onClick: onClick,
      target: isIframed() ? '_blank' : '_self',
      disabled: disabledData.isDisabled,
      block: true,
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "center",
        gap: 5,
        children: [/*#__PURE__*/_jsx(Image, {
          height: 22,
          width: 22,
          src: Images.passkeyLogo
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.form.passkey"
        })]
      })
    })
  });
};
export default PasskeyLoginButton;